<div class="content">
  <router-outlet />
</div>
